const loginHelpOptionsTemplate = `
   <pwr-login-help-no-record accu="accu">
   </pwr-login-help-no-record> `;
export default loginHelpOptionsTemplate;
